<template>
	<div class="order-header">
		
		
		<div class="bind_box">
			<div style="font-size:18px;padding:10px 0" >{{$t('other.a1923')}} {{$t('other.a964')}}{{total}}{{$t('other.a707')}}</div>
			<el-tabs v-model="this.$route.path" @tab-click="handleClick">
			   <el-tab-pane 
			   v-for="item in tabs"
			   :key="item.name"
			   :label="item.label"
			   :name="item.name"
			   >
			   </el-tab-pane>
			  
			</el-tabs>	
		</div>
		<div>
			 <keep-alive>
				   <router-view></router-view>
			   </keep-alive>
		</div>
	</div>
</template>

<script>
import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex'
	export default{
		data(){
			return {
				shopee:true,
				cusCode:null,
				groupId:null,
				itemNameQuery:null,
				tabs: [
				  { label: "shopee", name: "/binditems/shopee",},
				  { label: "lazada", name: "/binditems/lazada",},
				],
			}
    },
    computed: {
			...mapState({
				mygoodslist: state => state.mygoods.mygoodslist,
				userId: state => state.shopaccess.userInfo.userId,
				userName: state => state.shopaccess.userInfo.userName,
				userPos: state => state.shopaccess.userInfo.userPos,
				goodsTotal:state => state.mygoods.goodsTotal,
				successtotal:state => state.mygoods.successtotal,
				errorList:state => state.mygoods.errorList,
				succesList:state => state.mygoods.succesList,
				curCodeList:state => state.mygoods.curCodeList,
				lazadaitems:state => state.mygoods.lazadaitems,
				lazadaCount:state => state.mygoods.lazadaCount,
				cateGoryListCopy:state => state.mygoods.cateGoryListCopy,
				already:state => state.mygoods.already,
				
			}),
			
			total(){
				if(this.shopee){
					return this.goodsTotal
				}else{
					return this.lazadaCount
				}
			}
		},  
		created(){
			this.init()

		},
		
		methods: {
			init(){
				this.shopee=this.$route.path == '/binditems/shopee' ?  true : false
					this.cusCode=this.$route.query.cusCode
					this.groupId=this.$route.query.groupId
					this.itemNameQuery=this.$route.query.itemSku


					console.log(this.cusCode)
					console.log(this.groupId)
					console.log(this.itemNameQuery)
			},
			
			handleClick(tab, event,name) {
			  this.shopee=tab.name == '/binditems/shopee' ?  true : false
			  if(this.cusCode){
				   this.$router.push({path:tab.name,query:{cusCode:this.cusCode}})
			  }else{
				  this.$router.push({path:tab.name,query:{groupId:this.groupId,itemSku:this.itemNameQuery}})
			  }
			 
			  this.activeName = tab.name;
			 
			},
		}
		
	}
</script>

<style>
	
	/* .order-header{
		flex: 1;
		margin: 60px 0 0 235px;
	} */


	.order-header .bind_box{
		
		position: fixed;
		top:50px;
		z-index: 6;
		width: 100%;
		padding: 10px 10px;
		background-color: #fff;

	
	}
		.el-tabs__item{
		font-size: 25px!important;
	}
	
</style>
